import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import ProgramSignupSheetContent from './ProgramSignupSheetContent'
import type { ProgramSignupSheetViewModel } from './useProgramSignupSheetViewModel'

type Props = {
  viewModel: ProgramSignupSheetViewModel
}

export default function ProgramSignupSheet({ viewModel }: Props) {
  return (
    <BottomSheet
      open={viewModel.isSheetOpen}
      onDismiss={viewModel.closeSheet}
      snapPoints={({ maxHeight }) => [maxHeight * 0.92, maxHeight]}
      defaultSnap={({ snapPoints }) => snapPoints[0]}
      expandOnContentDrag
    >
      <div className="px-6 pb-8 pt-2">
        <ProgramSignupSheetContent viewModel={viewModel} />
      </div>
    </BottomSheet>
  )
}
